import {Component, Input, OnDestroy, OnInit} from '@angular/core';

import {TranslateService} from "@ngx-translate/core";

import {Vehicle} from '@commons/models/domain/Vehicle';
import {VehicleService} from '@commons/services/vehicle/vehicle.service';
import {SetSendToETollRequest} from '@commons/models/remote.request/SetSendToETollRequest';

import {EtollStatusHttpService} from "@layout/vehicle/http-services/etoll-status-http.service";

import {BaseComponent} from "@shared/components/base-component";
import { ETollDisableModalComponent } from './e-toll-disable-modal/e-toll-disable-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

@Component({
  selector: 'tk-vehicle-details-e-toll-tab',
  styleUrls: ['./vehicle-details-etoll-tab.component.scss'],
  templateUrl: './vehicle-details-etoll-tab.component.html'
})
export class VehicleDetailsETollTabComponent extends BaseComponent implements OnInit, OnDestroy {

  private readonly ComponentSubsc: Subscription = new Subscription();

  readyToShow = false;
  sendToEToll?: boolean;
  etollBalance?: string;

  @Input() vehicle!: Vehicle;

  get isETollPanelVisible(): boolean {
    return this.etollBalance != null;
  }

  buttonTurnOffEtollTitle = '';
  buttonTurnOnEtollTitle = '';
  supportUrl = '';

  constructor(
    private $vehicleService: VehicleService,
    private eTollStatusService: EtollStatusHttpService,
    private translateService: TranslateService,
    public dialog: MatDialog,
  ) {
    super();
    this.setTranslations();
  }

  private setTranslations() {
    this.translateService.get("vehicle-details-etoll-tab.button-turn-off-etoll").subscribe(t => this.buttonTurnOffEtollTitle = t);
    this.translateService.get("vehicle-details-etoll-tab.button-turn-on-etoll").subscribe(t => this.buttonTurnOnEtollTitle = t);
    this.translateService.get("help.support-url").subscribe(t => this.supportUrl = t);
  }

  ngOnDestroy(): void {
    this.unsubscribeAll();
    this.ComponentSubsc.unsubscribe();
  }

  ngOnInit(): void {
    this.GetSendToEToll();
    this.subToIsEtollDataAvailable();
  }

  private subToIsEtollDataAvailable() {
    this.addToUnsubscribe(
      this.eTollStatusService.isEtollDataAvailableSub.subscribe(isAvailable => {
        const isNotEtollDeviceErrorStatus = this.vehicle?.ES != 3;
        if (isNotEtollDeviceErrorStatus && isAvailable)
          this.trySetLastEtollBalanceFrom();
      }));
  }

  private trySetLastEtollBalanceFrom() {
    this.eTollStatusService.getBalanceDetails(this.vehicle?.Id).subscribe({
      next: (response) => {
        if (response.ErrorCode !== EtollStatusHttpService.noEtollDataForVehicleErrorCode)
          this.etollBalance = response.Result?.Result;
      }
    });
  }

  /**
   * włączenie/wyłączenie wysyłania danych do e-Toll
   */
  SaveSendToEToll(value: boolean) {
    const request: SetSendToETollRequest = {
      IdVehicle: this.vehicle!.Id!,
      SendToEToll: value
    };

    this.$vehicleService.setSendToEToll(request).subscribe(nothing => {
    });
    this.sendToEToll = value;
  }

  CopyAllData() {
    var valueToCopy: string = `Nazwa pojazdu: ${this.vehicle?.Nm}
Numer biznesowy: ${this.vehicle?.BN}
PIN: ${this.vehicle?.DP}
Dane z systemu MyCar www.tekom.pl`;
    this.CopyValue(valueToCopy);
  }

  CopyValue(value: string) {
    const selBox = document.createElement('textarea');
    selBox.value = value;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }

  public gotToSupport(): void {
    window.open('https://support.tekom.pl/portal/pl/kb/articles/etoll', '_blank');
  }

  GetSendToEToll() {
    this.$vehicleService.getSendToEToll(this.vehicle!.Id!).subscribe(
      (result) => {
        this.sendToEToll = result;
        this.readyToShow = true;
      }
    );
  }

  CopyBusinessNumber() {
    this.CopyValue(this.vehicle!.BN!);
  }

  CopyPin() {
    this.CopyValue(this.vehicle!.DP!);
  }

  ToggleChanged() {
    if (this.sendToEToll) {
      this.SaveSendToEToll(true);
    } else {
      this.ShowOverlay();
    }
  }

  ConfirmEtollDisabling() {
    this.SaveSendToEToll(false);
    this.sendToEToll = false;
  }

  CancelEtollDisabling() {
    this.sendToEToll = true;
  }

  private ShowOverlay() {
    this.showModalConfirmLock();
  }

  private showModalConfirmLock(): void {
    const dialog = this.dialog.open(ETollDisableModalComponent, { width: '100%', height: '100%', maxWidth: '100%' });
    const sub = dialog.afterClosed().subscribe(
      (res) => {
        if (res) {
          this.ConfirmEtollDisabling();
          return;
        }
        this.CancelEtollDisabling();
      }
    );
    this.ComponentSubsc.add(sub);
  }

}
